/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function(){
  /* click element */
  const reviewBadge = document.querySelector('.prorw_preview_badge_setup');
  /* target element */
  const tab = document.querySelector('[data-tab="reviews"]');
  if(reviewBadge != null && tab != null){
    /* badge click event */
    reviewBadge.addEventListener('click', function() {
      /* generate click event of target element */
      tab.dispatchEvent(new Event('click'));

      /* scroll to target element */
      var headerOffset = 160;
      if(window.innerWidth < 1000){
        headerOffset = 110;
      }
      if(window.innerWidth < 641){
        headerOffset = 70;
      }
      var elementPosition = tab.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
      window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
      });
    });
  }
});
